import { getTheme, INavLinkGroup, mergeStyleSets, Nav, INavProps, css, INavStyles, Icon, INavLink } from '@fluentui/react';
import * as React from 'react';
import { navigateTo } from '../src/hooks';
import { doLogin } from './LoginButton';

const ICON_SIZE = 16;
const productIcons = {
	wpconnectrpro: 'https://reenhanced.com/wp-content/uploads/2025/04/WPPowerPro-LOGO.png',
	gfpro:         'https://reenhanced.com/wp-content/uploads/2024/03/gf-pro-with-background.jpg',
	woopower:      'https://reenhanced.com/wp-content/uploads/2022/03/logo.jpg',
	pf7:           'https://reenhanced.com/wp-content/uploads/2020/10/icon.png',
	wpforms:       'https://reenhanced.com/wp-content/uploads/2023/09/combined-logo-1.png',
};

declare var require: any;
export const wordpresslogo = require('../src/assets/wordpress.svg');

const theme = getTheme();

const styles = mergeStyleSets({
	AppSidebar: [
		"AppSidebar",
		{
		backgroundColor: theme.palette.neutralLight,
		padding: '10px 0',
		borderRight: '1px solid rgb(210, 210, 210)',
		color: theme.palette.black
	}],
	collapseIcon: [
		"collapseIcon",
		{
		cursor: 'pointer',
		paddingLeft: '10px',
		textAlign: 'center'
		}]
});

const navHiddenStyles: Partial<INavStyles> = {
	linkText: {
		display: 'none'
	}
}

export const AppSidebar: React.FC<{loggedIn: boolean}> = (props) => {
	const [sidebarOpen, setSidebarOpen] = React.useState(window.innerWidth >= 800);

	const subscriptionsNav: INavLink = {
				key: 'subs',
				name: 'Subscriptions',
				url: '/subscriptions',
				icon: 'FavoriteList'
			};

	const loginNav: INavLink = {
		key: 'login',
		name: 'Login with WordPress.com',
		url: '/users/auth/wordpress',
		iconProps: {
			imageProps: {
				src: wordpresslogo,
				width: 16
			}
		},
		onClick: doLogin
	};

	const userNavGroups:INavLinkGroup[] = [{
		links: [
			{
				key: 'products',
				name: 'Products',
				icon: 'ProductList',
				isExpanded: true,
				url: '/products',
				links: [
					{
						key: 'wpconnectrpro',
						name: 'WP Connectr Pro',
						url: '/products/wp-connectr-pro',
						iconProps: { imageProps: { src: productIcons.wpconnectrpro, width: ICON_SIZE, height: ICON_SIZE } },
					},
					{
						key: 'gfpro',
						name: 'Gravity Forms Pro',
						url: '/products/gravity-forms-pro',
						iconProps: { imageProps: { src: productIcons.gfpro, width: ICON_SIZE, height: ICON_SIZE } },
					},
					{
						key: 'woopower',
						name: 'Power Automate for WooCommerce',
						url: '/products/woopower',
						iconProps: { imageProps: { src: productIcons.woopower, width: ICON_SIZE, height: ICON_SIZE } },
					},
					{
						key: 'pf7',
						name: 'Power Form 7',
						url: '/products/power-form-7',
						iconProps: { imageProps: { src: productIcons.pf7, width: ICON_SIZE, height: ICON_SIZE } },
					},
					{
						key: 'wpforms',
						name: 'Power Automate for WPForms',
						url: '/products/wpforms',
						iconProps: { imageProps: { src: productIcons.wpforms, width: ICON_SIZE, height: ICON_SIZE } },
					},
				]
			}]
	}];

	const navigateToItem: INavProps["onLinkClick"] = (ev, item) => {
		ev.preventDefault();
		navigateTo(item.url);
	}

	return (
		<div className={styles.AppSidebar}>
			<Icon iconName='GlobalNavButton' className={styles.collapseIcon} onClick={() => setSidebarOpen(!sidebarOpen) } />
			<Nav
				className={ `NavCollapsable ${sidebarOpen ? 'open' : ''}` }
				groups={userNavGroups}
				onLinkClick={navigateToItem}
				/>
		</div>
	)
}

export default AppSidebar;
